/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  Container, Grid, Segment, Header, Card, Table, Button, Search, List, Message,
  Popup,
} from 'semantic-ui-react';
import { Redirect } from 'react-router-dom';

import { getUserDisplayNameFromEmail } from '../../../helpers/format';
import { base, cloudFunctionsURL, firebaseAuth, REGEX_PATTERNS } from '../../../config/constants';
import { AlertBox, ConfirmBox, SelectBox, askConfirmation, setAlertMsg, pickOne } from '../../../components/Modals';

export default class ViewAdmin extends Component {
  static propTypes = {
    history: PropTypes.object,
    habilitations: PropTypes.object,
    match: PropTypes.object,
  }

  static defaultProps = {
    habilitations: { uid: null },
    match: { params: {} },
    history: null,
  }

  constructor(props) {
    super(props);
    this.state = {
      selectedAdmin: null,
      selectedAdminId: null,
      adminsLoading: true,
      selectedAdminLoading: !!props.match.params.id,
      gettingEmailVerificationStatus: false,
      settingEmailVerificationStatus: false,
      currentKnownEmailVerificationStatus: null,
      admins: [],
      search: {
        isLoading: false,
        value: '',
        results: [],
      },
      adding: {
        themes: false,
        citizenly: false,
        elected: false,
      },
    };
  }

  componentDidMount() {
    this._ismounted = true;
    // console.log('did mount ', this.props);
    base.bindToState('administrateurs', {
      context: this,
      state: 'admins',
      asArray: true,
      queries: {
        orderByChild: 'email',
        // limitToLast: 3
      },
      then: () => this.setState({ adminsLoading: false }),
    });
    if (this.props.match.params.id) {
      this.selectedBinding = base.bindToState(`administrateurs/${this.props.match.params.id}`, {
        context: this,
        state: 'selectedAdmin',
        then: () => this.setState({ selectedAdminLoading: false, selectedAdminId: this.props.match.params.id }),
      });
    }
  }

  componentWillUnmount() {
    this._ismounted = false;
    clearTimeout(this.timeOutForSearchChange);
  }

  getFormattedList = (themeType) => {
    let wordNone;
    switch (themeType) {
      case 'themes':
        wordNone = 'Aucune profession';
        break;
      case 'citizenly':
        wordNone = 'Aucune commune';
        break;
      case 'elected':
        wordNone = 'Aucune circonscription';
        break;
      default:
        wordNone = '-';
        break;
    }

    if (
      !themeType
      || !this.state.selectedAdmin
      || !this.state.selectedAdmin.habilitations
      || !this.state.selectedAdmin.habilitations[themeType]
    ) {
      return wordNone;
    }

    const themes = Object.keys(this.state.selectedAdmin.habilitations[themeType]);
    return (
      <List>
        {
          _.map(themes, item => (
            <List.Item key={item}>
              <List.Content>
                <Button
                  fluid
                  animated="fade"
                  color="blue"
                  compact
                  size="tiny"
                  onClick={() => this.handleDeleteThemeAccess(themeType, item, this.state.selectedAdminId)}
                >
                  <Button.Content visible>
                    {item.toUpperCase()}
                  </Button.Content>
                  <Button.Content hidden>
                    Supprimer
                  </Button.Content>
                </Button>
              </List.Content>
            </List.Item>
          ))
        }
      </List>
    );
  };

  selectedBinding;
  timeOutForSearchChange;
  _ismounted = false;

  handleResultSelect = (e, { result }) => {
    // console.log(result);
    // this.setState({ search: { ...this.state.search, value: result.title } });
    this.props.history.push(`/access-mgt/view/${result.key}`);
  };

  handleToggleSuperuser = (adminId, trueIfActivateRequest) => this.setState(askConfirmation(
    trueIfActivateRequest ? 'Activer les droits super administrateur ?' : 'Retirer les droits super administrateur ?',
    trueIfActivateRequest
      ? `L'utilisateur <strong>${getUserDisplayNameFromEmail(this.state.selectedAdmin.email)}</strong> pourra consulter, administrer, et envoyer des message à l'ensemble des professions, communes et circonscriptions.
        <br/><br/>Voulez-vous vraiment lui donner le statut "super administrateur" ?`
      : `L'utilisateur <strong>${getUserDisplayNameFromEmail(this.state.selectedAdmin.email)}</strong> ne pourra plus consulter, administrer, et envoyer des message à l'ensemble des professions, communes et circonscriptions.
        <br/><br/>Voulez-vous vraiment lui retirer le statut "super administrateur" ?`,
    trueIfActivateRequest ? 'warn' : 'neutral',
    () => {
      if (trueIfActivateRequest) {
        base.update(`administrateurs/${adminId}/habilitations`, { data: { superuser: true } }).catch((error) => {
          this.setState(setAlertMsg(error.code || null, 'Impossible de donner l\'accès', error.toString(), 'error'));
        });
      } else {
        base.remove(`administrateurs/${adminId}/habilitations/superuser`).catch((error) => {
          this.setState(setAlertMsg(error.code || null, 'Impossible de retirer l\'accès', error.toString(), 'error'));
        });
      }
    },
    trueIfActivateRequest ? 'OUI, ACTIVER' : 'OUI, RETIRER',
  ))


  handleGetEmailVerificationStatus = () => {
    const { email } = this.state.selectedAdmin;
    if (!REGEX_PATTERNS.email.test(email)) {
      return this.setState(setAlertMsg(
        null,
        'Adresse email invalide',
        'L\'administrateur ne semble pas avoir une adresse email valide.',
        'error',
      ));
    }
    this.setState({ gettingEmailVerificationStatus: true });
    firebaseAuth().currentUser.getIdToken(/* forceRefresh */ false)
      .then(idToken => fetch(`${cloudFunctionsURL}/getEmailVerificationStatusFromEmail/?email=${encodeURIComponent(email)}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }).then(resp => resp.json()).then((data) => {
        if (data.found) {
          this.setState({
            gettingEmailVerificationStatus: false,
            currentKnownEmailVerificationStatus: data.emailVerified,
          });
        }
      }))
      .catch(error => this.setState({
        ...setAlertMsg(error.code || null, 'Erreur lors de la consultation', error.toString(), 'error'),
        gettingEmailVerificationStatus: false,
      }));
    return true;
  }

  handleForceEmailVerificationStatus = () => {
    const { email } = this.state.selectedAdmin;
    if (!REGEX_PATTERNS.email.test(email)) {
      return this.setState(setAlertMsg(
        null,
        'Adresse email invalide',
        'L\'administrateur ne semble pas avoir une adresse email valide.',
        'error',
      ));
    }
    this.setState({ settingEmailVerificationStatus: true });
    firebaseAuth().currentUser.getIdToken(/* forceRefresh */ false)
      .then(idToken => fetch(`${cloudFunctionsURL}/forceEmailVerificationStatusFromEmail/?email=${encodeURIComponent(email)}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }).then(resp => resp.json()).then((data) => {
        if (data.found && data.emailVerified) {
          this.setState({
            settingEmailVerificationStatus: false,
            currentKnownEmailVerificationStatus: data.emailVerified,
          });
        }
      }))
      .catch(error => this.setState({
        ...setAlertMsg(error.code || null, 'Erreur lors de la consultation', error.toString(), 'error'),
        settingEmailVerificationStatus: false,
      }));
    return true;
  }

  handleAddThemeAccess = (themeType, adminId) => {
    if (adminId !== this.state.selectedAdminId) {
      return false;
    }
    this.setState({ adding: { ...this.state.adding, [themeType]: true } });
    // console.log('handleAddThemeAccess', themeType, adminId, { adding: { ...this.state.adding, [themeType]: true } });
    // console.log(this.state);

    let word;
    switch (themeType) {
      case 'themes':
        word = 'une profession';
        break;
      case 'citizenly':
        word = 'une commune';
        break;
      case 'elected':
        word = 'une circonscription';
        break;
      default:
        word = '';
        break;
    }

    return base.fetch(`${themeType}`, {
      context: this,
      asArray: true,
    }).then((data) => {
      // console.log(data);
      const options = _.map(data, source => ({
        key: source.key,
        value: source.key,
        text: `${source.nom} (${source.key})`,
      }));
      this.setState({
        ...pickOne(
          `Ajouter ${word}`,
          `Vous souhaitez ajouter un accès à l'administrateur suivant:<br/>
           <strong>${getUserDisplayNameFromEmail(this.state.selectedAdmin.email)}</strong>.<br/><br/>
           Pour cela, veuillez choisir ${word} dans la liste ci-dessous puis cliquer sur "Ajouter" :`,
          'create',
          (themeId) => {
            base.update(`administrateurs/${adminId}/habilitations/${themeType}`, { data: { [themeId]: true } }).catch((error) => {
              this.setState(setAlertMsg(
                error.code || null,
                'Impossible de donner l\'accès',
                error.toString(),
                'error',
              ));
            });
          },
          options,
          'Ajouter',
          `Sélectionnez ${word}`,
        ),
        adding: { ...this.state.adding, [themeType]: false },
      });
    }).catch((error) => {
      this.setState({
        ...setAlertMsg(error.code || null, 'Impossible de récupérer la liste', error.toString(), 'error'),
        adding: { ...this.state.adding, [themeType]: false },
      });
    });
  }

  handleDeleteThemeAccess = (themeType, themeId, adminId) => {
    let word;
    switch (themeType) {
      case 'themes':
        word = 'la profession ';
        break;
      case 'citizenly':
        word = 'la commune ';
        break;
      case 'elected':
        word = 'la circonscription de ';
        break;
      default:
        word = '';
        break;
    }
    return this.setState(askConfirmation(
      `Retirer l'accès à ${word} ?`,
      `L'utilisateur <strong>${getUserDisplayNameFromEmail(this.state.selectedAdmin.email)}</strong> ne pourra plus administrer, ni envoyer de message à ${word}<strong>${themeId.toUpperCase()}</strong><br/><br/>Voulez-vous vraiment lui retirer cet accès ?`,
      'warn',
      () => {
        base.remove(`administrateurs/${adminId}/habilitations/${themeType}/${themeId}`).catch((error) => {
          this.setState(setAlertMsg(error.code || null, 'Impossible de retirer l\'accès', error.toString(), 'error'));
        });
      },
      'OUI, RETIRER',
    ));
  }

  handleDeleteAdmin = adminId => this.setState(askConfirmation(
    'Supprimer l\'administrateur ?',
    `L'utilisateur <strong>${getUserDisplayNameFromEmail(this.state.selectedAdmin.email)}</strong> ne disposera plus d'aucun accès.<br/><br/>Voulez-vous vraiment le supprimer ?`,
    'destructive',
    () => {
      base.remove(`administrateurs/${adminId}`).catch((error) => {
        this.setState(setAlertMsg(
          error.code || null,
          'Impossible de supprimer cet administrateur',
          error.toString(),
          'error',
        ));
      });
    },
    'OUI, SUPPRIMER',
  ))


  handleSearchChange = (e, { value }) => {
    this.setState({ search: { ...this.state.search, isLoading: true, value } });


    this.timeOutForSearchChange = setTimeout(() => {
      // if (this.state.search.value.length < 1) return this.resetSearchComponent();
      if (value.length < 1) return this.resetSearchComponent();

      const re = new RegExp(_.escapeRegExp(this.state.search.value), 'i');
      const isMatch = result => re.test(result.email);
      const map = {
        key: 'userid',
      };
      if (!this._ismounted) return true;
      this.setState({
        search: {
          ...this.state.search,
          isLoading: false,
          results: _.map(_.filter(this.state.admins, isMatch), a => _.reduce(a, (result, v, key) => {
            // eslint-disable-next-line no-param-reassign
            result[key] = v;
            if (map[key]) {
              // eslint-disable-next-line no-param-reassign
              result[map[key]] = v;
            }
            // console.log(result);
            return result;
          }, {})),
        },
      });
      return true;
    }, 100);
  }


  resetSearchComponent = () => this.setState({ search: { isLoading: false, results: [], value: '' } });

  render() {
    const noneSelected = this.state.selectedAdmin === null;
    const selfIsSelected = !noneSelected && this.state.selectedAdminId === this.props.habilitations.uid;
    const habObject = noneSelected ? {} : (this.state.selectedAdmin.habilitations || {});
    const admin = this.state.selectedAdmin;
    let emailVerifButtonText;
    let emailVerifButtonIcon;
    let emailVerifButtonColor;
    if (this.state.currentKnownEmailVerificationStatus === true) {
      emailVerifButtonText = 'Email vérifié';
      emailVerifButtonIcon = 'checkmark';
      emailVerifButtonColor = 'green';
    } else if (this.state.currentKnownEmailVerificationStatus === false) {
      emailVerifButtonText = 'Email non vérifié';
      emailVerifButtonIcon = 'hide';
      emailVerifButtonColor = 'red';
    } else {
      emailVerifButtonText = 'Consulter le statut "Email vérifié"';
      emailVerifButtonIcon = 'question';
      emailVerifButtonColor = 'blue';
    }

    if (
      this.props.match.params.id && !this.state.adminsLoading && !this.state.selectedAdminLoading
      && (noneSelected || !this.state.selectedAdmin.email)
    ) {
      return <Redirect to="/access-mgt/view" />;
    }

    return (<Container>
      <Segment basic loading={this.state.adminsLoading}>
        <Grid columns={2}>

          <Grid.Column width={6}>
            <Grid.Row>
              <Segment textAlign="center" basic>
                <Header textAlign="center" size="small">
                  Sélectionnez un administrateur
                </Header>
                <Search
                  fluid
                  selectFirstResult
                  input={{ autoFocus: true }}
                  noResultsMessage={this.state.search.isLoading ? 'Recherche en cours' : 'Aucun résultat'}
                  noResultsDescription="Évitez les accents et caractères spéciaux."
                  onResultSelect={this.handleResultSelect}
                  onSearchChange={_.debounce(this.handleSearchChange, 500, { leading: true })}
                  loading={this.state.search.isLoading}
                  results={this.state.search.results}
                  value={this.state.search.value}
                  resultRenderer={({ email }) => (
                    <div>
                      <Header size="small">
                        {getUserDisplayNameFromEmail(email)}
                      </Header>
                      {email}
                    </div>
                  )}
                />
                {noneSelected ? (
                  <Message compact info>
                    Utilisez le champ de recherche ci-dessus pour sélectionner l'administrateur dont
                    vous souhaitez éditer les droits d'accès.
                  </Message>
                ) : (
                  <Message compact>
                    Vous pouvez utiliser ce champ de recherche pour afficher un autre administrateur.
                  </Message>
                )}
              </Segment>
            </Grid.Row>
          </Grid.Column>
          <Grid.Column width={10}>
            <Grid.Row>
              <Segment basic loading={!this.state.adminsLoading && this.state.selectedAdminLoading}>
                <Card fluid raised={!noneSelected}>
                  <Card.Content>
                    <Card.Header
                      size="small"
                      content={
                        !noneSelected ?
                          getUserDisplayNameFromEmail(admin.email) : 'Utilisez le champ de recherche à gauche.'
                      }
                    />
                    <Card.Meta
                      content={
                        !noneSelected ?
                          admin.email : 'Aucun administrateur sélectionné'
                      }
                    />
                  </Card.Content>
                  <Card.Content>
                    <Card.Meta
                      content="Habilitations de l'administrateur sélectionné"
                    />
                    <Table definition={!noneSelected} color={!noneSelected ? 'blue' : null}>
                      <Table.Body>
                        <Table.Row disabled={noneSelected}>
                          <Table.Cell>Super administrateur</Table.Cell>
                          <Table.Cell>
                            <Button
                              fluid
                              animated="fade"
                              color={
                                noneSelected || !habObject.superuser
                                  ? null : 'red'
                              }
                              disabled={noneSelected || selfIsSelected}
                              onClick={
                                () => noneSelected
                                  || this.handleToggleSuperuser(this.state.selectedAdminId, !habObject.superuser)
                              }
                            >
                              <Button.Content visible>
                                {noneSelected || !habObject.superuser ? 'Désactivé' : 'Activé'}
                              </Button.Content>
                              <Button.Content hidden>
                                {noneSelected || !habObject.superuser ? 'Activer' : 'Désactiver'}
                              </Button.Content>
                            </Button>
                          </Table.Cell>
                          <Table.Cell />
                        </Table.Row>
                        <Table.Row disabled={noneSelected}>
                          <Table.Cell>Professionnels</Table.Cell>
                          <Table.Cell textAlign="center">{this.getFormattedList('themes')}</Table.Cell>
                          <Table.Cell collapsing>
                            <Popup
                              trigger={
                                <Button
                                  icon="add"
                                  color="green"
                                  inverted
                                  circular
                                  disabled={noneSelected}
                                  loading={this.state.adding.themes}
                                  onClick={
                                    () => noneSelected
                                      || this.handleAddThemeAccess('themes', this.state.selectedAdminId)
                                  }
                                />
                              }
                            >
                              <Popup.Content>Ajouter une profession</Popup.Content>
                            </Popup>
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row disabled={noneSelected}>
                          <Table.Cell>Participation Citoyenne</Table.Cell>
                          <Table.Cell textAlign="center">{this.getFormattedList('citizenly')}</Table.Cell>
                          <Table.Cell collapsing>
                            <Popup
                              trigger={
                                <Button
                                  icon="add"
                                  color="green"
                                  inverted
                                  circular
                                  disabled={noneSelected}
                                  loading={this.state.adding.citizenly}
                                  onClick={
                                    () => noneSelected
                                      || this.handleAddThemeAccess('citizenly', this.state.selectedAdminId)
                                  }
                                />
                              }
                            >
                              <Popup.Content>Ajouter une commune</Popup.Content>
                            </Popup>
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row disabled={noneSelected}>
                          <Table.Cell>Contact Élus</Table.Cell>
                          <Table.Cell textAlign="center">{this.getFormattedList('elected')}</Table.Cell>
                          <Table.Cell collapsing>
                            <Popup
                              trigger={
                                <Button
                                  icon="add"
                                  color="green"
                                  inverted
                                  circular
                                  disabled={noneSelected}
                                  loading={this.state.adding.elected}
                                  onClick={
                                    () => noneSelected
                                      || this.handleAddThemeAccess('elected', this.state.selectedAdminId)
                                  }
                                />
                              }
                            >
                              <Popup.Content>Ajouter une circonscription</Popup.Content>
                            </Popup>
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </Card.Content>
                  <Card.Content>
                    <Segment basic textAlign="center">
                      <Button
                        content="Supprimer cet administrateur"
                        icon="remove"
                        color="red"
                        inverted
                        onClick={() => this.handleDeleteAdmin(this.state.selectedAdminId)}
                        disabled={noneSelected || selfIsSelected}
                      />
                    </Segment>
                    <Segment basic textAlign="center">
                      <Button
                        content={emailVerifButtonText}
                        icon={emailVerifButtonIcon}
                        color={emailVerifButtonColor}
                        inverted={this.state.currentKnownEmailVerificationStatus !== true}
                        onClick={() => this.handleGetEmailVerificationStatus()}
                        disabled={noneSelected || selfIsSelected}
                        loading={this.state.gettingEmailVerificationStatus}
                      />
                      <Button
                        content="Forcer la vérification"
                        icon="checkmark"
                        color="blue"
                        onClick={() => this.handleForceEmailVerificationStatus()}
                        disabled={this.state.currentKnownEmailVerificationStatus !== false}
                        loading={this.state.settingEmailVerificationStatus}
                      />
                    </Segment>
                  </Card.Content>
                </Card>
              </Segment>
            </Grid.Row>
          </Grid.Column>
        </Grid>
      </Segment>
      <AlertBox
        propagateClosure={() => this.setState({ alert: { open: false } })}
        {...this.state.alert}
      />
      <ConfirmBox
        propagateClosure={() => this.setState({ confirm: { open: false } })}
        {...this.state.confirm}
      />
      <SelectBox
        propagateClosure={() => this.setState({ pick: { open: false } })}
        {...this.state.pick}
      />
            </Container>);
  }
}



// WEBPACK FOOTER //
// ./src/screens/protected/AccessManagement/ViewAdmin.js